const messages_fr = {

};

export default messages_fr